<template>
    <base-modal
        :id="id"
        :centered="false"
        :modal-class="['base-sheet', `base-sheet-${width}`]"
        scrollable
        v-bind="$attrs"
        v-on="$listeners"
    >
        <template v-for="(_, name) in $scopedSlots" #[name]="scope">
            <slot :name="name" v-bind="scope"></slot>
        </template>
    </base-modal>
</template>

<script>
import BaseModal from '@/core/components/BaseModal.vue';

export default {
    name:         'base-sheet',
    components:   { BaseModal },
    inheritAttrs: false,
    model:        {
        prop:  'visible',
        event: 'change'
    },
    props: {
        id: {
            type:     String,
            required: true
        },
        width: {
            type:      String,
            default:   'md',
            validator: value => ['md', 'lg'].includes(value)
        }
    }
};
</script>
